module.exports = __webpack_public_path__ + "img/main_3_1_2.4ec5ebd1.png";